module.exports = __webpack_public_path__ + "img/Stars_xs.7d260ce4.png";